import styled from 'styled-components';
import { Flag } from '@xingternal/flag';
const FlagWrapper = styled.div `
  line-height: 0;
`;
const FlagWithPointer = styled(Flag) `
  cursor: pointer;
  position: relative;
  z-index: 50;
`;
export const Styled = {
    FlagWrapper,
    FlagWithPointer,
};
//# sourceMappingURL=styles.js.map